import { API_BASE } from './storageMode';

/**
 * Upload an image file.
 * In production the file is posted to the PHP API and a URL is returned.
 * In prototype/dev mode the file is converted to a base64 data URL so it can
 * live in localStorage.
 */
export const uploadImageFile = async (file, storageMode) => {
    if (storageMode === 'api') {
        const formData = new FormData();
        formData.append('image', file);

        const response = await fetch(`${API_BASE}/upload.php`, {
            method: 'POST',
            credentials: 'include',
            body: formData
        });

        const data = await response.json();

        if (data.success) {
            return data.url;
        }
        throw new Error(data.error || 'Upload failed');
    }

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = () => reject(new Error('Failed to read file'));
        reader.readAsDataURL(file);
    });
};
